export default "__VITE_ASSET__BnrHF76b__"